import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

import { useLogoutMutation } from "../redux/services/auth";
import {
  setActivityAccessToken,
  setLoggedIn,
  setCheckingSession,
} from "../redux/slices/authSlice";
import { useLazyGetMeQuery } from "../redux/services/users";
import { isEmpty } from "lodash";
import Cookies from "js-cookie";
import { useGetTokenMutation } from "../redux/services/emissionActivities";
import { useGrigetTokenMutation } from "../redux/services/grireport";

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [loggedInUser, setLoggedInUser] = useState({});
  const [selectedNode, setSelectedNode] = useState({ id: null, name: "" });
  const [dateRange, setDateRange] = useState([
    dayjs(`${dayjs().year()}-01`, "YYYY-MM"),
    dayjs(`${dayjs().year()}-12`, "YYYY-MM"),

  ]);
  const [regiongridata, setregiongridata] = useState([]);
  const [materialtopics,setmaterialtopics] = useState([])

  const [dashboardnode, setdahboardnode] = useState([]);

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const updateNode = (id, name) => {
    setSelectedNode({ id, name });
  };

  const [logout] = useLogoutMutation();

  const authState = useSelector((store) => store?.auth);
  const [emissionActivityLogin, { data }] = useGetTokenMutation();

  const [getUserData, { data: userData, isSuccess: loggedInSuccess }] =
    useLazyGetMeQuery();

  console.log("accessisheredata", data);

  const handleLogin = () => {};
  const handleLogout = async () => {
    await logout();
    dispatch(setLoggedIn(false));
    localStorage.clear();
  };

  // Validate existing session on every app load / page refresh.
  // Skip on the login page — user is not authenticated yet, and calling
  // the endpoint would trigger a 401 redirect loop.
  useEffect(() => {
    if (window.location.pathname === "/login") {
      dispatch(setCheckingSession(false));
      return;
    }
    getUserData()
      .unwrap()
      .then((data) => {
        setLoggedInUser(data);
        dispatch(setLoggedIn(true));
      })
      .catch(() => {
        dispatch(setLoggedIn(false));
      })
      .finally(() => {
        dispatch(setCheckingSession(false));
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loggedInSuccess) {
      setLoggedInUser(userData);
    }
  }, [loggedInSuccess, userData]);

  useEffect(() => {
    if (data?.access_token) {
      dispatch(setActivityAccessToken(data?.access_token));
    }
  }, [dispatch, data?.access_token]);

  // useEffect(() => {
  //   if (data1?.access_token) {
  //     dispatch(setActivityAccessToken(data?.access_token));
  //   }
  // }, [dispatch, data1?.access_token]);

  // useEffect(() => {
  //   if (sessionData?.data?.access_token) {
  //     dispatch(setAccessToken(sessionData?.data?.access_token));
  //     getUserData();
  //     emissionActivityLogin();
  //   }
  // }, [sessionData, dispatch, emissionActivityLogin, getUserData]);

  // useEffect(() => {
  //   if (sessionData?.data?.access_token) {
  //     dispatch(setAccessToken(sessionData?.data?.access_token));
  //     getUserData();
  //     emissionActivityLogin();
  //   }
  // }, [sessionData, dispatch, emissionActivityLogin1, getUserData]);

  const isKarbonWiseAdmin = loggedInUser?.role === 9;
  const isAccountOwner = loggedInUser?.role === 3;
  const isAccountStaff = loggedInUser?.role === 4;
  const isCompanyAdmin = loggedInUser?.role === 1;
  const isCompanyStaff = loggedInUser?.role === 2;

  return (
    <AuthContext.Provider
      value={{
        authState,
        activityAccessToken: authState?.activityAccessToken,
        accessToken: authState?.accessToken,
        isAuthenticated: authState?.isLoggedIn === true,
        handleLogin,
        handleLogout,
        isKarbonWiseAdmin,
        setdahboardnode,
        dashboardnode,
        setregiongridata,
        isAccountOwner,
        setmaterialtopics,
        regiongridata,
        isAccountStaff,
        materialtopics,
        isCompanyAdmin,
        selectedNode,
        updateNode,
        isCompanyStaff,
        loggedInUser,
        dateRange,
        setDateRange: handleDateRangeChange,
        getLoggedInUser: getUserData,
        // getSession: refetch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
